import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const CATEGORY_CONFIG = {
  // Old endpoint for backward compatibility
  CATEGORY_LIST: {
    endPoint: 'category',
    method: 'GET',
    baseUrlKey: 'inventoryApiUrl',
  },
  // New dynamic dropdown endpoint
  CATEGORY_DROPDOWN_LIST: (dropdownType = '') => ({
    endPoint: `dropdowns/${dropdownType}`,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
  }),
}